<div class="stars">
    <!-- <p>Rate this page</p>

    <div id="container">
        <i [class.rated]="rating>=5" class="bi bi-star" (click)="setRating(5)"></i>
        <i [class.rated]="rating>=4" class="bi bi-star" (click)="setRating(4)"></i>
        <i [class.rated]="rating>=3" class="bi bi-star" (click)="setRating(3)"></i>
        <i [class.rated]="rating>=2" class="bi bi-star" (click)="setRating(2)"></i>
        <i [class.rated]="rating>=1" class="bi bi-star" (click)="setRating(1)"></i>
    </div> -->
</div>